import { Button, Layout, StateInfoBox } from "@/components";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { PAGES, TELEGRAM_SUPPORT_BOT_URL } from "@/config";
import { AppImage } from "@/components";
import iconTelegramColor from "@/assets/images/socials/logo-telegram-color.svg";
import { usePaymentStore } from "@/store/usePaymentStore";

import styles from "./ErrorPage.module.sass";

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const verifyPaymentStatus = usePaymentStore(
    (state) => state.verifyPaymentStatus,
  );
  const intentLoading = usePaymentStore((state) => state.intentLoading);
  const { message, data } = location.state || {};

  const token = useMemo(() => {
    return data?.token;
  }, [data?.token]);

  const clientSecret = useMemo(() => {
    return data?.clientSecret;
  }, [data?.clientSecret]);

  const handleVerifyPaymentStatus = async () => {
    if (!clientSecret || !token || intentLoading) {
      return;
    }

    const isConfirmed = await verifyPaymentStatus(clientSecret, token);
    if (isConfirmed) {
      navigate(PAGES.AML_CHECK);
    }
  };

  return (
    <Layout
      title="Error"
      isShowBackButton
      onBack={() => navigate(PAGES.AML_HISTORY)}
    >
      <div className={styles.error}>
        <StateInfoBox type="error" title={message} />

        {token && (
          <>
            <div className={styles.support}>
              If the problem persists, please contact our support team at{" "}
              <a
                href={TELEGRAM_SUPPORT_BOT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.telegram}
              >
                <AppImage src={iconTelegramColor} alt="Telegram Icon" />
                <span>Telegram</span>
              </a>{" "}
              and provide this token:{" "}
              <span className={styles.token}>{token}</span>
            </div>

            {clientSecret && (
              <>
                <div className={styles.or}>Or</div>
                <div className={styles.verify}>
                  Try to verify payment intent status manually
                  <Button
                    disabled={intentLoading}
                    onClick={handleVerifyPaymentStatus}
                    text="Verify"
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default ErrorPage;
